var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_437_15952)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.1898 2H7.81977C4.17977 2 2.00977 4.17 2.00977 7.81V16.18C2.00977 19.82 4.17977 21.99 7.81977 21.99H16.1898C19.8298 21.99 21.9998 19.82 21.9998 16.18V7.81C21.9998 4.17 19.8298 2 16.1898 2Z",
    fill: "#97A1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1103 11.1499H7.46031C7.31057 11.1498 7.16227 11.1792 7.0239 11.2364C6.88553 11.2937 6.7598 11.3776 6.65392 11.4835C6.54803 11.5894 6.46407 11.7151 6.40682 11.8535C6.34958 11.9919 6.32018 12.1402 6.32031 12.2899V17.4099H10.1103V11.1499Z",
    fill: "#97A1C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.7606 6.59998H11.2406C11.0908 6.59984 10.9425 6.62924 10.8042 6.68649C10.6658 6.74373 10.5401 6.8277 10.4342 6.93358C10.3283 7.03947 10.2443 7.16519 10.1871 7.30356C10.1299 7.44193 10.1005 7.59023 10.1006 7.73998V17.4H13.8906V7.73998C13.8918 7.59078 13.8634 7.44282 13.8072 7.30463C13.7509 7.16643 13.6679 7.04073 13.5629 6.93477C13.4578 6.8288 13.3329 6.74467 13.1952 6.68721C13.0575 6.62975 12.9098 6.6001 12.7606 6.59998Z",
    fill: "#97A1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5504 12.85H13.9004V17.4H17.6904V13.99C17.687 13.6887 17.5658 13.4007 17.3528 13.1876C17.1397 12.9745 16.8517 12.8534 16.5504 12.85Z",
    fill: "#97A1C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_15952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload8);
export default __webpack_public_path__ + "static/media/download 8.5f96345eadc06f466ad276b19b624ba9.svg";
export { ForwardRef as ReactComponent };